<template>
  <div>
    <Modal
      v-model="modalAdd"
      title="新增学校"
      :closable="false"
      :mask-closable="false"
      @on-ok="addRecord"
    >
      <div class="add-item">
        <span>学校名称：</span>
        <Input class="input" v-model="add_school_title" placeholder="请输入学校名称" clearable />
      </div>
      <div class="add-item">
        <span>教室id：</span>
        <Input class="input" v-model="add_serial_number" placeholder="请输入教室id" clearable />
      </div>
      <div class="add-item">
        <span>申请人数：</span>
        <Input class="input" v-model="add_apply_for_count" placeholder="请输入申请人数" clearable />
      </div>
      <div class="add-item">
        <span>标准人数：</span>
        <Input class="input" v-model="add_pass_count" placeholder="请输入标准人数" clearable />
      </div>
      <div class="add-item">
        <span>权重：</span>
        <Input class="input" v-model="add_sort" placeholder="请输入权重" clearable />
      </div>
    </Modal>
    <div class="table-head">
      <Button @click="modalAdd = true">新增</Button>
    </div>
    <Table :columns="columns" :data="schoolList">
      <template slot-scope="{ row }" slot="index">
        <span>{{ row.index }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="school_title">
        <template v-if="editIndex === index">
          <i-Input type="text" v-model="update_school_title" />
        </template>
        <span v-else>{{ row.school_title }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="serial_number">
        <template v-if="editIndex === index">
          <i-Input type="text" v-model="update_serial_number" />
        </template>
        <span v-else>{{ row.serial_number }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="apply_for_count">
        <template v-if="editIndex === index">
          <i-Input type="text" v-model="update_apply_for_count" />
        </template>
        <span v-else>{{ row.apply_for_count }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="pass_count">
        <template v-if="editIndex === index">
          <i-Input type="text" v-model="update_pass_count" />
        </template>
        <span v-else>{{ row.pass_count }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="sort">
        <template v-if="editIndex === index">
          <i-Input type="text" v-model="update_sort" />
        </template>
        <span v-else>{{ row.sort }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <div v-if="editIndex === index">
          <Button @click="handleSave(index)" :disabled="action_btn_disabled">保存</Button>
          <Button
            style="margin-left: 10px"
            @click="editIndex = -1"
            :disabled="action_btn_disabled"
          >取消</Button>
        </div>
        <div v-else>
          <Button @click="handleEdit(row, index)">编辑</Button>
          <!--          <Button style="margin-left: 10px" @click="deleteRecord(row, index)">删除</Button>-->
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import apis from "../../http/api";

export default {
  data() {
    return {
      modalAdd: false,
      editIndex: -1,
      action_btn_disabled: false,
      add_school_title: "",
      add_serial_number: "",
      add_apply_for_count: "",
      add_pass_count: "",
      add_sort: "",
      update_school_title: "",
      update_serial_number: "",
      update_apply_for_count: "",
      update_pass_count: "",
      update_sort: "",
      schoolList: [],
      columns: [
        {
          title: '学校排序',
          slot: 'index',
          // width: 70
        },
        {
          title: '学校名称',
          slot: 'school_title',
          // width: 120
        },
        {
          title: '教室id',
          slot: 'serial_number'
        },
        {
          title: '申请人数',
          slot: 'apply_for_count'
        },
        {
          title: '标准人数',
          slot: 'pass_count'
        },
        {
          title: '权重',
          slot: 'sort'
        },
        {
          title: '操作',
          slot: 'action',
          width: 180
        }
      ]
    }
  },
  async created() {
    await this.getList()
  },
  methods: {
    async addRecord() {
      let post_data = {
        school_title: this.add_school_title,
        serial_number: this.add_serial_number,
        apply_for_count: this.add_apply_for_count,
        pass_count: this.add_pass_count,
        sort: this.add_sort,
      }
      apis.active_add_school(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.getList()
          this.add_school_title = ""
          this.add_serial_number = ""
          this.add_apply_for_count = ""
          this.add_pass_count = ""
          this.add_sort = ""
        }else {
          this.$Message.error(msg);
        }
      }).catch(res => {
        console.log(res)
      })
    },
    async getList() {
      apis.get_school_list().then(res => {
        console.log(res)
        this.schoolList = res.data.records
      })
    },
    handleEdit(row, index) {
      this.action_btn_disabled = false;
      this.update_school_title = row.school_title;
      this.update_serial_number = row.serial_number;
      this.update_apply_for_count = row.apply_for_count;
      this.update_pass_count = row.pass_count;
      this.update_sort = row.sort;
      this.editIndex = index;
    },
    handleSave(index) {
      this.action_btn_disabled = true;
      this.updateRecord(index);
      this.editIndex = -1;
    },
    updateRecord(index) {
      let post_data = {
        id: this.schoolList[index].id,
        school_title: this.update_school_title,
        serial_number: this.update_serial_number,
        apply_for_count: this.update_apply_for_count,
        pass_count: this.update_pass_count,
        sort: this.update_sort,
      }
      apis.update_school_info(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode !== 0) {
          this.$Message.error(msg);
        }
        this.getList()
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-head {
  text-align: right;
  padding: 5px;
}
.add-item {
  display: flex;
  align-items: center;
  margin-left: 65px;
}
.add-item {
  padding-bottom: 10px;
}
.add-item span {
  width: 20%;
}
.input {
  width: 60%;
}
</style>
